// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__zNTje","marketplaceStroke":"IconEmailAttention_marketplaceStroke__aS6EL","attentionStroke":"IconEmailAttention_attentionStroke__2vkA4"};